export default function About() {
  const stats = [
    { number: '500+', label: 'Projects Completed' },
    { number: '50M+', label: 'SF Estimated' },
    { number: '98%', label: 'On-Time Delivery' }
  ];

  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl h-96 lg:h-[600px] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20construction%20consulting%20team%20reviewing%20BIM%20models%20and%20blueprints%20in%20modern%20office%20with%20large%20monitors%20showing%203D%20building%20models%2C%20diverse%20group%20of%20engineers%20and%20architects%20collaborating%2C%20bright%20contemporary%20workspace%20with%20glass%20walls%20and%20natural%20lighting%2C%20business%20professional%20atmosphere&width=800&height=1000&seq=about-team-001&orientation=portrait"
                alt="Our Team"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute top-6 left-6 bg-orange-600 text-white px-4 py-2 rounded-lg font-semibold text-sm whitespace-nowrap">
                SINCE 2005
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Engineering Excellence Through Technology
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              We are a specialized consulting firm dedicated to delivering precision estimating, advanced BIM modeling, and comprehensive scheduling services for large-scale construction projects.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Our team of experienced professionals combines deep industry knowledge with cutting-edge technology to help clients navigate the complexities of mega projects, from initial planning through successful completion.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mb-8">
              {stats.map((stat, index) => (
                <div key={index} className="text-center lg:text-left">
                  <div className="text-4xl lg:text-5xl font-bold text-orange-600 mb-2">
                    {stat.number}
                  </div>
                  <div className="text-sm text-gray-600 font-medium">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}